import type { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { defaultLayoutComponents, defaultLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

const ManageTemplatesRoute: RouteRecordRaw = {
	path: '/manage-templates',
	name: ROUTE_KEYS.MANAGE_TEMPLATES,
	meta: {
		label: 'manage-templates.page-title',
		auth: true,
		isFixedEntry: true,
		icon: () => $i('table')
	},
	props: {
		...defaultLayoutProps
	},
	components: {
		default: () => import('./manage-templates.page.vue'),
		...defaultLayoutComponents
	}
};

export default ManageTemplatesRoute;
